"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../../utils/Styles");

var _Heading = _interopRequireDefault(require("../Heading"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H7 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H7",
  componentId: "c9mzup-0"
})(_templateObject(), _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT7], (0, _Styles.setFontSize)(_sizes.HEADING7));
H7.propTypes = _Heading.default.propTypes;
H7.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h2'
});
H7.displayName = 'H7';
var _default = H7;
exports.default = _default;
module.exports = exports.default;